import circle from "@turf/circle";
import { executeSQL } from "@carto/react-api";
import { MILES } from "utils/constants";

export const ISOLINE_MODES = {
  RADIUS: "radius",
  WALK: "walking",
  TIME: "isochrone",
};

export const MEASUREMENT_BY_MODE = {
  [ISOLINE_MODES.RADIUS]: "distance",
  [ISOLINE_MODES.WALK]: "time",
  [ISOLINE_MODES.TIME]: "time",
};

// TODO: Should use metadata.measurements
export const ISOLINE_UNITS = {
  [ISOLINE_MODES.RADIUS]: "m",
  [ISOLINE_MODES.WALK]: "minutes",
  [ISOLINE_MODES.TIME]: "minutes",
};

// TODO: Should use metadata.measurements
export const ISOLINE_FULL_UNITS = {
  [ISOLINE_MODES.RADIUS]: "meters",
  [ISOLINE_MODES.WALK]: "minutes",
  [ISOLINE_MODES.TIME]: "minutes",
};

export const ISOLINE_LABELS = {
  [ISOLINE_MODES.RADIUS]: "radius distance",
  [ISOLINE_MODES.WALK]: "walking time",
  [ISOLINE_MODES.TIME]: "driving time",
};

export const ISOLINE_MARKS = {
  [ISOLINE_MODES.RADIUS]: [250, 500, 1000],
  [ISOLINE_MODES.WALK]: [5, 10, 15],
  [ISOLINE_MODES.TIME]: [5],
};

export const TRADE_AREA_LABELS = {
  0: "All",
  3: "Top 3",
  10: "Top 10",
  "-3": "Bottom 3",
  "-10": "Bottom 10",
};

export const MILES_TO_METERS = 1609.344;
export const METERS_TO_MILES = 0.000621371192;
export const KILOMETERS_TO_METERS = 1000;
export const MINUTES_TO_SECONDS = 60;

export async function getIsoline(
  credentials,
  {
    center,
    range = 250,
    unit = "meters",
    mode = ISOLINE_MODES.RADIUS,
    abortController,
  }
) {
  if (isNaN(center[0]) || isNaN(center[1])) {
    return null;
  }

  if (unit === MILES) {
    range = range * MILES_TO_METERS;
  }

  if (unit === "kilometers") {
    range = range * KILOMETERS_TO_METERS;
  }

  if (mode === ISOLINE_MODES.RADIUS) {
    return circle(center, range, { units: "meters" });
  }

  const quotaCheck = await executeSQL({
    credentials,
    query: `select cdb_enough_quota('isolines', 1) as enough`,
    opts: { abortController },
  });
  if (!quotaCheck[0].enough) {
    throw new Error("Not enough quota available for this month");
  }

  let query = "";
  if (mode === ISOLINE_MODES.WALK) {
    // for mode 'isodistance' range is in meters
    query = `
      SELECT ST_AsGeoJSON(the_geom) as the_geom FROM cdb_isochrone(
        'POINT(${center.join(" ")})'::geometry,
        'walk',
        ARRAY[${range * MINUTES_TO_SECONDS}]::integer[]
      )
    `;
  }

  if (mode === ISOLINE_MODES.TIME) {
    // for mode isodistance range is in minutes
    query = `
      WITH coords AS (
        SELECT
            (ST_DumpPoints(the_geom)).geom as geom
        FROM cdb_isochrone(
            'POINT(${center.join(" ")})'::geometry,
            'car',
            ARRAY[${range * MINUTES_TO_SECONDS}]::integer[]
        )
      )
      SELECT
        ST_AsGeoJSON(ST_MakePolygon(
          ST_MakeLine(
            ST_MAKEPOINT(
              ROUND(ST_X(geom)::DECIMAL, 5),
              ROUND(ST_Y(geom)::DECIMAL, 5) 
                )
              ))) as the_geom
      FROM coords

    `;
  }

  const data = await executeSQL({
    credentials,
    query,
    opts: { abortController },
  });
  const geom = JSON.parse(data[0].the_geom);

  return {
    type: "Feature",
    geometry: geom,
  };
}
